class StoreDetails extends HTMLElement {
  constructor() {
    super();
    this.latitude = Number(this.dataset.latitude);
    this.longitude = Number(this.dataset.longitude);
    this.template = this.querySelector("template");
  }

  connectedCallback() {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.dataset.apiKey}&callback=apiLoaded`;
    document.body.appendChild(script);

    window.apiLoaded = () => {
      this.initMap();
    };
  }

  async initMap() {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    let marker;
    let map;

    map = new Map(document.getElementById("map"), {
      center: {
        lat: this.latitude,
        lng: this.longitude,
      },
      zoom: 15,
      disableDefaultUI: true,
      mapId: "b30082d2bdd86a0",
    });

    const clone = this.template.content.cloneNode(true);
    const content = document.createElement("div");
    content.appendChild(clone);

    marker = new AdvancedMarkerElement({
      map,
      position: { lat: this.latitude, lng: this.longitude },
      content,
      gmpClickable: true,
    });

    marker.addListener("click", () => {
      this.toggleInfo(marker);
    });
  }

  toggleInfo(marker) {
    if (marker.classList.contains("open")) {
      marker.classList.remove("open");
    } else {
      marker.classList.add("open");
    }
  }
}

if (!customElements.get("store-details")) {
  customElements.define("store-details", StoreDetails);
}
